import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { Box, Button, Container, Grid, Typography, useTheme } from "@mui/material";
import CommonContainer from "../../Components/Landing/CommonContainer";
import { get_posts_public, getallaboutUs_public } from "../../Redux/Actions/action";
import { showLoader } from "../../Redux/Slices/loaderSlice";
import ReachOut from "../../Components/Landing/ReachOut";
import AboutUsCommon from "../../Components/Landing/AboutUsCommon";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  variableWidth: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 992,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 576,
      settings: { slidesToShow: 1, dots: false },
    },
  ],
};

const Dashboard = () => {
  const theme = useTheme()
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const bucketUrl = 'https://webitodevelopment.s3.ap-south-1.amazonaws.com/'

  const [heroSectionData, setHeroSectionData] = useState([])
  const [heroEventData, setHeroEventData] = useState([])
  const [margdarshakMemberData, setMargdarshakMemberData] = useState([])
  const [officeBearerSectionData, setOfficeBearerSectionData] = useState([])
  const [karobariMembersData, setkarobariMembersData] = useState([])
  const [aboutUsData, setAboutUsData] = useState([]);

  const fetchData = async (params, setter) => {
    dispatch(showLoader(true));
    try {
      const res = await dispatch(get_posts_public(params));
      if (res?.payload?.data?.data) {
        setter(res.payload.data.data);
      }
      dispatch(showLoader(false));
    } catch (err) {
      console.error('Error:', err);
      dispatch(showLoader(false));
    }
  };

  const _getallaboutUs = async (params, setter) => {
    dispatch(showLoader(true));
    try {
      const res = await dispatch(getallaboutUs_public({}));
      setAboutUsData(res.payload?.data?.response?.[0]);
      dispatch(showLoader(false));
    } catch (err) {
      dispatch(showLoader(false));
    }
  };

  const _getPpskEvents = async () => {
    dispatch(showLoader(true));
    try {
      const res = await dispatch(get_posts_public({ type: 'Event', status: 'Active', page: 1 }));
      const data = res.payload?.data?.data || res.payload?.data || [];
      setHeroEventData(Array.isArray(data) ? data : []);
      dispatch(showLoader(false));
    } catch (err) {
      console.error('Error:', err);
      dispatch(showLoader(false));
    }
  };

  useEffect(() => {
    fetchData(
      {
        type: 'Hero-Banner', status: 'Active', page: 1,
        // limit: 10
      },
      setHeroSectionData
    );
    fetchData(
      {
        type: 'Office-Member',
        status: 'Active',
        memberType: 'Office-Bearer',
        page: 1,
        // limit: 10,
      },
      setOfficeBearerSectionData
    );
    fetchData(
      {
        type: 'Office-Member',
        status: 'Active',
        memberType: 'Margdarshak-Member',
        page: 1,
        // limit: 10,
      },
      setMargdarshakMemberData
    );
    fetchData(
      {
        type: 'Office-Member',
        status: 'Active',
        memberType: 'Karobari-Member',
        page: 1,
        // limit: 10,
      },
      setkarobariMembersData
    );
    _getPpskEvents()
    _getallaboutUs()
  }, []);

  return (
    <>
      <Box>
        {heroSectionData?.map((item, index) => (
          <Box key={index} sx={{ position: 'relative' }}>
            <img
              src={bucketUrl + item.heroBannerDetails?.bannerImage}
              alt={item.heroBannerDetails?.eventName || 'Hero Banner'}
              style={{ filter: 'brightness(0.5)', width: '100%', objectFit: 'cover', maxHeight: '720px' }}
            />
            <Box sx={{
              position: 'absolute', zIndex: 1, top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)', textAlign: 'center', color: "#fff",
              maxWidth: '1200px', width: '100%'
            }} >
              <Typography
                sx={{
                  fontSize: { lg: "34px", md: "20px", sm: "16px", xs: "16px" },
                  fontWeight: "bold",
                }}
              >
                સમસ્ત પાટીદાર સમાજ ટ્રસ્ટ સુરત.
              </Typography>
              <Typography fontWeight={"bold"} sx={{
                fontSize: { lg: "24px", md: "14px", sm: "14px", xs: "14px" },

              }} >અંતર્ગત :</Typography>
              <Typography
                sx={{
                  fontSize: { lg: "64px", md: "38px", sm: "32px", xs: "22px" },
                  fontWeight: "700",
                }}
              >
                પાટીદાર પરિવાર સુરક્ષા કવચ
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <AboutUsCommon data={aboutUsData} />
      <CommonContainer>
        <Box sx={{ backgroundColor: '#d2e7e8', padding: { lg: "50px", md: "36px", sm: "24px", xs: "16px" }, borderRadius: '20px' }}>
          <Grid container spacing={2} position={"relative"}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Typography
                color={"primary"}
                sx={{
                  fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
                  fontWeight: "bold",
                  mb: { lg: 1.5, md: 1.5, sm: 1, xs: 0.2 },
                  lineHeight: '60px',
                  textAlign: "center",
                  mt: { lg: "18px", md: "18px", sm: "10px", xs: "4px" },
                }}
              >
                Why PPSK?
              </Typography>
              <Typography sx={{ fontSize: { lg: "26px", md: "16px", sm: "16px" }, fontWeight: '600', color: '#4e4e4e', textAlign: "center", marginBottom: { lg: "40px", md: "30px", sm: "26px", xs: "26px" } }}>
                પીપીએસકે પાટીદાર પરિવારોને સમયસર સહાય અને સુરક્ષા આપે છે.
              </Typography>
              <video controls width="100%" style={{ borderRadius: '20px', }}>
                <source src="/images/01.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Grid>
          </Grid>
        </Box>
      </CommonContainer>
      <Container sx={{ mt: { lg: '100px', md: '80px', sm: "40px", xs: '20px', } }}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            color={"primary"}
            sx={{
              fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "20px" },
              fontWeight: "bold",
            }}
          >
            PPSK Events
          </Typography>
          <Typography
            color={"primary"}
            sx={{
              fontSize: { lg: "18px", md: "16px", sm: "16px", xs: "12px" },
              fontWeight: "bold",
              textDecoration: "underline",
              cursor: 'pointer'
            }}
            onClick={() => navigate(`/events`)}
          >
            View All
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: { lg: "20px", md: "16px", sm: "16px", xs: "12px" },
            color: '#4b4c4c',
            mb: { lg: 3, mg: 3, sm: 2, xs: 1 }

          }}
        > PPSK events foster unity and well-being through community gatherings, health camps, and cultural programs.</Typography>
      </Container>
      <Box className="slider-container ppsk-event " sx={{
        maxWidth: '1920px',
      }}>
        <Container>
          <Slider {...sliderSettings}>
            {Array.isArray(heroEventData) && heroEventData.map((event, i) => {
              return (<>
                <Box key={event._id} sx={{ width: '98% !important' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      '&:hover .hover-button': {
                        bottom: '0%',
                        opacity: 1,
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={bucketUrl + event?.ppskEventImages}
                      alt={event?.eventName || 'Event'}
                      sx={{
                        width: '100%',
                        mb: 2,
                        margin: '0px',
                        height: {
                          lg: 350,
                          md: 300,
                          sm: 250,
                          xs: 200,
                        },
                        objectFit: "cover",
                        borderRadius: "12px",
                        display: "block",
                      }}
                      loading="lazy"
                    />
                    {/* <Button
                      variant="contained"
                      className="hover-button"
                      onClick={() => navigate(`/event/${event._id}`)}
                      sx={{
                        position: 'absolute',
                        zIndex: 1,
                        left: '50%',
                        bottom: '-20%',
                        transform: 'translateX(-50%)',
                        opacity: 0,
                        transition: 'bottom 0.3s ease, opacity 0.4s ease',
                        borderRadius: '10px',
                        fontSize: { lg: "18px", md: '16px', sm: '14px', xs: '12px' },
                        padding: { lg: '6px 24px', sm: '6px 20px' },
                        marginBottom: "109px",
                        transition: 'all 0.5s ease',
                        '&:hover': {
                          backgroundColor: "#9e110c"
                        }
                      }}
                    >
                      View Gallery
                    </Button> */}
                  </Box>
                </Box>
              </>
              );
            })}
          </Slider>
        </Container>
      </Box>
      <CommonContainer>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ mb: { lg: 3, mg: 3, sm: 2, xs: 1 } }}
        >
          <Typography
            color={"primary"}
            sx={{
              fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
              fontWeight: "bold",
              textAlign: 'center',
            }}
          >
            PPSK Office Bearer
          </Typography>
        </Box>
        <Grid container spacing={{ lg: 5, md: 3, sm: 2, xs: 1 }} justifyContent="center">
          {officeBearerSectionData?.map((item, i) => {
            const member = item?.officeMember;
            return (
              <Grid item lg={4} md={4} sm={6} xs={12} style={{ position: 'relative' }} key={i}>
                <Box sx={{ padding: "15px", backgroundColor: '#deedee', borderRadius: '20px' }}>
                  <Box
                    component="img"
                    src={bucketUrl + member?.memberImage}
                    alt={member?.memberName || "Member Image"}
                    sx={{
                      width: "100%",
                      height: {
                        lg: 450,
                        md: 300,
                        sm: 300,
                        xs: 250,
                      },
                      objectFit: "cover",
                      borderRadius: "12px",
                      display: "block",
                    }}
                    loading="lazy"
                  />
                  <Box mt={1} textAlign="center">
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: {
                          lg: "26px",
                          md: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        fontWeight: "bold",
                      }}
                    >
                      {member?.memberName}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "20px",
                          md: "14px",
                          sm: "12px",
                          xs: "12px",
                        },
                        color: "#222222",
                      }}
                    >
                      {member?.memberDesignation}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CommonContainer>
      <CommonContainer>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ mb: { lg: 3, mg: 3, sm: 2, xs: 1 } }}
        >
          <Typography
            color={"primary"}
            sx={{
              fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
              fontWeight: "bold",
              textAlign: 'center',
            }}
          >
            સમસ્ત પાટીદાર સમાજના અગ્રણીશ્રી માર્ગદર્શક ટીમ
          </Typography>
        </Box>
        <Grid container spacing={{ lg: 5, md: 3, sm: 2, xs: 1 }} justifyContent="center">
          {margdarshakMemberData?.map((item, i) => {
            const member = item?.officeMember;
            return (
              <Grid item lg={4} md={4} sm={6} xs={12} style={{ position: 'relative' }} key={i}>
                <Box sx={{ padding: "15px", backgroundColor: '#deedee', borderRadius: '20px' }}>
                  <Box
                    component="img"
                    src={bucketUrl + member?.memberImage}
                    alt={member?.memberName || "Member Image"}
                    sx={{
                      width: "100%",
                      height: {
                        lg: 450,
                        md: 300,
                        sm: 300,
                        xs: 250,
                      },
                      objectFit: "cover",
                      borderRadius: "12px",
                      display: "block",
                    }}
                    loading="lazy"
                  />
                  <Box mt={1} textAlign="center">
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: {
                          lg: "26px",
                          md: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        fontWeight: "bold",
                      }}
                    >
                      {member?.memberName}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "20px",
                          md: "14px",
                          sm: "12px",
                          xs: "12px",
                        },
                        color: "#222222",
                      }}
                    >
                      {member?.memberDesignation}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}

        </Grid>
      </CommonContainer>
      <CommonContainer>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ mb: { lg: 3, mg: 3, sm: 2, xs: 1 } }}
        >
          <Typography
            color={"primary"}
            sx={{
              fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
              fontWeight: "bold",
              textAlign: 'center',
            }}
          >
            પાટીદાર પરિવાર સુરક્ષા કવચ ટીમ
          </Typography>
        </Box>
        <Grid container spacing={{ lg: 5, md: 3, sm: 2, xs: 1 }} justifyContent="center">
          {karobariMembersData?.map((item, i) => {
            const member = item?.officeMember;
            return (
              <Grid item lg={4} md={4} sm={6} xs={12} style={{ position: 'relative' }} key={i}>
                <Box sx={{ padding: "15px", backgroundColor: '#deedee', borderRadius: '20px' }}>
                  <Box
                    component="img"
                    src={bucketUrl + member?.memberImage}
                    alt={member?.memberName || "Member Image"}
                    sx={{
                      width: "100%",
                      height: {
                        lg: 450,
                        md: 300,
                        sm: 300,
                        xs: 250,
                      },
                      objectFit: "cover",
                      borderRadius: "12px",
                      display: "block",
                    }}
                    loading="lazy"
                  />
                  <Box mt={1} textAlign="center">
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: {
                          lg: "26px",
                          md: "16px",
                          sm: "16px",
                          xs: "16px",
                        },
                        fontWeight: "bold",
                      }}
                    >
                      {member?.memberName}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "20px",
                          md: "14px",
                          sm: "12px",
                          xs: "12px",
                        },
                        color: "#222222",
                      }}
                    >
                      {member?.memberDesignation}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}

        </Grid>
      </CommonContainer>
      <CommonContainer>
        <Typography
          color={"primary"}
          sx={{
            fontSize: { lg: "54px", md: "20px", sm: "16px", xs: "20px" },
            fontWeight: "bold",
            mb: { lg: 3, mg: 3, sm: 2, xs: 1 },
            textAlign: 'center'
          }}
        >
          Get a Application
        </Typography>
        <Box>
          <img
            src="/images/Frame-10000084741.svg"
            alt="logo"
            style={{ width: "100%", objectFit: "cover" }}
          />
        </Box>
      </CommonContainer>
      <ReachOut />
    </>
  );
};

export default Dashboard;
